import {
  DroidMapMetadata,
  ServiceClient,
  ServiceClientContext,
} from '@droidmap/shared-service-contract'

import { BasemapToken } from '../models/basemap-token.js'
import {
  AutoStretch,
  CogInfo,
  GetAutoStretchInput,
  GetCogInfoInput,
} from '../models/tile.js'

export class TileServiceClient extends ServiceClient {
  public static readonly SERVICE_NAME = 'TileService'

  constructor(input: ServiceClientContext) {
    super({ ...input, serviceName: TileServiceClient.SERVICE_NAME })
  }

  getCogInfo = async (
    getCogInfoInput: GetCogInfoInput,
    metadata: DroidMapMetadata,
  ): Promise<CogInfo> => {
    const { assetId } = getCogInfoInput

    const cogInfo = await this.callApiRouteWithToken<GetCogInfoInput, CogInfo>({
      method: 'GET',
      path: `/cog/assets/${assetId}/info`,
      metadata,
    })

    return cogInfo
  }

  getAutoStretch = async (
    input: GetAutoStretchInput,
    metadata: DroidMapMetadata,
  ): Promise<AutoStretch> => {
    const { assetId, bidx, expression } = input

    return this.callApiRouteWithToken<void, AutoStretch>({
      method: 'GET',
      path: `/cog/assets/${assetId}/stretch`,
      queryParameters: bidx
        ? { bidx: bidx.map(String) }
        : expression !== undefined
          ? { expression }
          : undefined,
      metadata,
    })
  }

  getBasemapToken = async (
    metadata: DroidMapMetadata,
  ): Promise<BasemapToken> => {
    return this.callApiRouteWithToken<void, BasemapToken>({
      method: 'GET',
      path: '/basemaps/token',
      metadata,
    })
  }
}
